<template>
  <div>
    <v-row>
      <v-col cols="12" sm="12" md="12">
        <v-data-table :loading="carregando ? 'success' : null" no-data-text="Nenhum Horário encontrada(o)!"
          loading-text="Carregando os itens desta tabela! Aguarde..." :headers="colunas" :header-props="headerProps"
          :items="listaHorarios" :items-per-page="-1" hide-default-footer class="elevation-0">
          <template v-slot:top>
            <v-row>
              <v-col class="botao-novo" cols="12" sm="12" md="12">
                <v-btn class="btn-novo-horario" @click="abrirModalHorarios()">
                  <v-icon>mdi-plus</v-icon>
                  NOVO
                </v-btn>
              </v-col>
            </v-row>
          </template>
          <template v-slot:item.diaSemana="{ item }">
            {{enumDiaSemana.find((x) => x.value === item.diaSemana)?.text}}
          </template>
          <template v-slot:item.actions="{ item }">
            <v-btn class="mx-2" x-small fab color="success" @click="abrirModalHorariosParaEdicao(item)"
              title="Editar Horário">
              <v-icon small>mdi-pencil</v-icon>
            </v-btn>
            <v-btn class="mx-2" x-small fab color="error" @click="excluirHorario(item)" title="Excluir Horário">
              <v-icon small>mdi-minus</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-dialog persistent v-model="modalHorarios" max-width="900px" class="horario-modal">
      <div class="horario-modal-container">
        <div class="modal-header">
          <div class="header-content">
            <div class="header-left">
              <div class="header-icon">
                <v-icon class="header-icon-white">{{ iconeTituloHorarios }}</v-icon>
              </div>
              <div class="header-text">
                <h2 class="header-title">{{ tituloHorarios }}</h2>
                <p class="header-subtitle">Configure os horários da agenda</p>
              </div>
            </div>
          </div>
        </div>
        <div class="unified-content">
          <v-card class="unified-card">
            <div class="form-content">
              <validation-observer ref="observerHorarios" v-slot="{ }">
                <form>
                  <v-row>
                    <v-col cols="12" md="3" sm="12">
                      <soi-select :label="'Dias'" :items="enumDiaSemana" v-model="horarioAgenda.diaSemana"
                        :nullable="false"></soi-select>
                    </v-col>
                    <v-col cols="12" md="3" sm="3">
                      <soi-input type="time" :name="'Início'" v-model="horarioAgenda.horaInicio" :label="'Início'"
                        :rules="{ required: true }"></soi-input>
                    </v-col>
                    <v-col cols="12" md="3" sm="3">
                      <soi-input type="time" :name="'Fim'" v-model="horarioAgenda.horaFim" :label="'Fim'"
                        :rules="{ required: true }"></soi-input>
                    </v-col>
                    <v-col cols="12" md="3" sm="3">
                      <soi-input type="time" :name="'Intervalo'" v-model="horarioAgenda.intervalo" :label="'Intervalo'"
                        :rules="{ required: true }"></soi-input>
                    </v-col>
                  </v-row>
                </form>
              </validation-observer>
            </div>
            <div class="form-actions">
              <div class="actions-container">
                <v-btn class="action-btn cancel-btn" :class="'warning'" @click="fecharModal()">
                  <v-icon left>mdi-keyboard-return</v-icon>
                  Voltar
                </v-btn>
                <v-btn class="action-btn save-btn" @click="salvar()" :loading="carregando" :disabled="carregando">
                  <v-icon left>$saveIcon</v-icon>
                  Salvar
                </v-btn>
              </div>
            </div>
          </v-card>
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import HorarioAgenda from '../../models/agenda/HorarioAgenda';
import {
  AlertaExclusaoQuestaoBooleano,
  AlertaPerguntaSimOuNaoBooleano,
  AlertaPerguntaSimOuNaoBooleanoHtml,
} from '../../helpers/MensagemHelper';
import { DiaSemana } from '../../models/Enums';
import { AgendaService } from '@/services/AgendaService';
import { HorarioAgendaService } from '@/services/HorarioAgendaService';
import { IHorarioReservado } from '@/models/agenda/IHorarioReservado';

export default Vue.extend({
  name: 'soi-horarioAgenda',
  props: {
    value: {
      type: Array as () => HorarioAgenda[],
      required: true,
    },
    agendaId: {
      type: Number,
      required: true,
    },
  },
  computed: {
    tituloHorarios() {
      return this.editarHorarios ? 'Editar Horarios' : 'Criar Horarios';
    },
    iconeTituloHorarios() {
      return this.editarHorarios ? 'mdi-clock-edit' : 'mdi-clock-plus';
    },
  },
  watch: {
    value() {
      this.listaHorarios = this.value;
    },
  },
  data() {
    return {
      carregando: false,
      horarioAgenda: new HorarioAgenda(),
      listaHorarios: this.value,
      modalHorarios: false,
      editarHorarios: false,
      horarioAgendaEdicaoIndex: -1,
      enumDiaSemana: DiaSemana,
      agendaService: new AgendaService(),
      horarioAgendaService: new HorarioAgendaService(),
      headerProps: {
        sortByText: 'Ordenar por',
      },
      avisoValidacaoHorarios: `- O horário possui agendamentos ativos.<br>
        - A alteração será aplicada somente a novos agendamentos.<br>
        - Nenhum agendamento já existente será afetado.`,
      colunas: [
        {
          text: 'Dias',
          align: 'center',
          value: 'diaSemana',
          filterable: true,
          sortable: true,
        },
        {
          text: 'Início',
          align: 'center',
          value: 'horaInicio',
          filterable: true,
          sortable: true,
        },
        {
          text: 'Fim',
          align: 'center',
          value: 'horaFim',
          filterable: true,
          sortable: true,
        },
        {
          text: 'Intervalo',
          align: 'center',
          value: 'intervalo',
          filterable: true,
        },
        {
          text: 'Ações',
          align: 'center',
          value: 'actions',
        },
      ],
    };
  },
  methods: {
    async salvar() {
      if (this.editarHorarios && !await AlertaPerguntaSimOuNaoBooleano('Se o horário possuir agendamentos ativos, a alteração será aplicada somente a novos agendamentos. Nenhum agendamento já existente será afetado.', 'Atenção, deseja prosseguir com a ação?')) {
        return;
      }
      const diaDaSemana = this.horarioAgenda.diaSemana === this.enumDiaSemana
        .find((dia: { text: string; }) => dia.text === 'Todos').value;

      if (diaDaSemana) {
        await this.configurarHorariosTodosDias();
        this.editarHorarios = false;
        this.modalHorarios = false;
        return;
      }

      const valid = await (this.$refs.observerHorarios as any).validate();

      if (!valid) {
        return;
      }

      if (this.editarHorarios) {
        if (this.horarioAgendaEdicaoIndex !== -1) {
          Object.assign(this.listaHorarios[this.horarioAgendaEdicaoIndex], this.horarioAgenda);
        }
      } else {
        this.listaHorarios.push(this.horarioAgenda);
      }

      this.$emit('input', this.listaHorarios);
      this.editarHorarios = false;
      this.modalHorarios = false;
      this.horarioAgenda = new HorarioAgenda();
      await (this.$refs.observerHorarios as any).reset();
    },
    async verificarSeDiaDaSemanaJaEstaCadastradoNaAgenda(agendaId: number, diaDaSemana: number): Promise<boolean> {
      const horarios = await this.horarioAgendaService.BuscarHorariosPorAgenda(agendaId);

      if (horarios && horarios.data.length === 0) {
        return false;
      }

      return horarios.data.some((horario: { diaSemana: number; }) => horario.diaSemana === diaDaSemana);
    },
    abrirModalHorarios() {
      this.modalHorarios = true;
      this.horarioAgenda = new HorarioAgenda();
      this.editarHorarios = false;
    },
    async abrirModalHorariosParaEdicao(horario: HorarioAgenda) {
      this.consolidarEdicao(horario);
    },
    consolidarEdicao(horario: HorarioAgenda) {
      this.horarioAgendaEdicaoIndex = this.listaHorarios.indexOf(horario);
      this.editarHorarios = true;
      this.modalHorarios = true;
      setTimeout(() => {
        this.horarioAgenda = { ...horario };
      }, 10);
    },
    async excluirHorario(horario: HorarioAgenda) {
      if (!await AlertaPerguntaSimOuNaoBooleano('Se o horário possuir agendamentos ativos, a alteração será aplicada somente a novos agendamentos. Nenhum agendamento já existente será afetado.', 'Atenção, deseja prosseguir com a ação?')) {
        return;
      }

      this.consolidarExclusao(horario);
    },
    consolidarExclusao(horario: HorarioAgenda) {
      const index = this.listaHorarios.indexOf(horario);
      this.listaHorarios.splice(index, 1);
      this.$emit('input', this.listaHorarios);
    },
    configurarHorariosTodosDias() {
      const diaDaSemana = this.horarioAgenda.diaSemana === this.enumDiaSemana.find((dia: { text: string; }) => dia.text === 'Todos').value;

      if (diaDaSemana) {
        const todosDias = this.enumDiaSemana.map((dia: { value: any; }) => dia.value);

        todosDias.forEach((dia: any) => {
          const diaDaSemanaTodos = dia !== this.enumDiaSemana.find((d: { text: string; }) => d.text === 'Todos').value; // Verifica se não é o dia "Todos"

          if (diaDaSemanaTodos) {
            const horarioExistente = this.listaHorarios.find((horario: { diaSemana: any; }) => horario.diaSemana === dia);
            const horariosModelo = { ...this.horarioAgenda, diaSemana: dia };

            if (horarioExistente) {
              Object.assign(horarioExistente, horariosModelo);
            } else {
              this.listaHorarios.push(horariosModelo);
            }
          }
        });

        this.$emit('input', this.listaHorarios);
      }
    },
    async fecharModal() {
      this.modalHorarios = false;
      this.editarHorarios = false;
      await (this.$refs.observerHorarios as any).reset();
      this.horarioAgenda = new HorarioAgenda();
    },
    async obterTodosOsHorariosAgendadosDesdeAgora(): Promise<IHorarioReservado[]> {
      try {
        const todosHorariosReservados = await this.agendaService.ObterTodosOsHorariosReservadosDesdeHoje();
        const agora = new Date();

        if (todosHorariosReservados && todosHorariosReservados.data) {
          const horariosFiltradosPorAgandamentoeDataFim = todosHorariosReservados.data.filter((item: { tipo: string; dataFim: string | number | Date; }) => item.tipo === 'AGENDAMENTO' && new Date(item.dataFim) > agora);
          return Array.isArray(horariosFiltradosPorAgandamentoeDataFim) ? horariosFiltradosPorAgandamentoeDataFim : [];
        }

        return [];
      } catch (error) {
        console.error('Erro ao buscar bloqueios e feriados:', error);
        return [];
      }
    },
  },
});
</script>

<style scoped>
/* BOTÃO NOVO MODERNO */
.btn-novo-horario {
  background: var(--especialidade-primary, #2e4b9d) !important;
  color: white !important;
  border-radius: 12px !important;
  padding: 12px 24px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  font-size: 14px !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
  transition: all 0.3s ease !important;
  margin-bottom: 16px !important;
}

.btn-novo-horario:hover {
  background: var(--especialidade-secondary, #4a6bb5) !important;
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(46, 75, 157, 0.3) !important;
}

.btn-novo-horario .v-icon {
  color: white !important;
  margin-right: 8px !important;
}

/* MODAL HORÁRIOS - ESTILO MODERNO */
.horario-modal {
  z-index: 9999 !important;
}

.horario-modal-container {
  background: white;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  max-width: 900px;
  margin: 0 auto;
}

/* HEADER MODERNO */
.modal-header {
  background: var(--especialidade-primary, #2e4b9d);
  padding: 24px 32px;
  position: relative;
}

.header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 16px;
}

.header-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 12px;
}

.header-icon-white {
  color: white !important;
  font-size: 24px !important;
}

.header-text {
  flex: 1;
}

.header-title {
  color: white;
  font-size: 24px;
  font-weight: 600;
  margin: 0;
  line-height: 1.2;
}

.header-subtitle {
  color: rgba(255, 255, 255, 0.8);
  font-size: 14px;
  margin: 4px 0 0 0;
  font-weight: 400;
}

.close-btn {
  color: white !important;
  opacity: 0.8;
  transition: opacity 0.2s ease;
}

.close-btn:hover {
  opacity: 1;
  background: rgba(255, 255, 255, 0.1) !important;
}

/* CONTEÚDO UNIFICADO */

.unified-card {
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(0, 0, 0, 0.05);
}

.form-content {
  padding: 32px;
}

/* INPUTS MODERNOS */
.soi-input, .soi-select {
  margin-bottom: 16px;
}

.soi-input .v-input__control,
.soi-select .v-input__control {
  border-radius: 12px !important;
  border: 2px solid #e0e0e0 !important;
  transition: all 0.3s ease !important;
}

.soi-input .v-input__control:hover,
.soi-select .v-input__control:hover {
  border-color: var(--especialidade-primary, #2e4b9d) !important;
  box-shadow: 0 0 0 3px rgba(46, 75, 157, 0.1) !important;
}

.soi-input .v-input__control:focus-within,
.soi-select .v-input__control:focus-within {
  border-color: var(--especialidade-primary, #2e4b9d) !important;
  box-shadow: 0 0 0 3px rgba(46, 75, 157, 0.2) !important;
}

/* AÇÕES */
.form-actions {
  padding: 24px 32px 32px 32px;
  border-top: 1px solid #f0f0f0;
  background: #fafafa;
}

.actions-container {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.action-btn {
  padding: 12px 24px !important;
  border-radius: 12px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  font-size: 14px !important;
  min-width: 120px !important;
  height: 44px !important;
  transition: all 0.3s ease !important;
}

.cancel-btn:hover {
  background: var(--especialidade-gradient, #2e4b9d) !important;
  color: #ffffff !important;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.save-btn {
  background: var(--especialidade-primary, #2e4b9d) !important;
  color: white !important;
  border: 2px solid var(--especialidade-primary, #2e4b9d) !important;
}

.save-btn:hover {
  background: var(--especialidade-secondary, #4a6bb5) !important;
  border-color: var(--especialidade-secondary, #4a6bb5) !important;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(46, 75, 157, 0.3);
}

.save-btn .v-icon {
  color: white !important;
}

.cancel-btn .v-icon {
  color: #ffffff !important;
}

/* RESPONSIVIDADE */
@media (max-width: 768px) {
  .horario-modal-container {
    margin: 16px;
    max-width: calc(100vw - 32px);
  }

  .modal-header {
    padding: 20px 24px;
  }

  .header-title {
    font-size: 20px;
  }

  .form-content {
    padding: 24px;
  }

  .form-actions {
    padding: 20px 24px 24px 24px;
  }

  .actions-container {
    flex-direction: column;
  }

  .action-btn {
    width: 100% !important;
  }
}
</style>
